// The app's color system. Every value aliases a Meridian source so raw-hex consumers and
// Meridian-themed components never drift apart:
//   - grays  -> aimsGrayPalette (meridian-theme-aims-gray.json)
//   - teals  -> aimsPalette (meridian-theme-aims.json), the brand ramp Meridian consumes
//   - accent/reds -> Meridian base color tokens
// Only pure white/black and the lavender surface stay hardcoded (no Meridian equivalent).
import { colorSuccess500, colorError50, colorError200, colorError800, colorRed100, colorCrimson600 } from "@amzn/meridian-tokens/base/color";
import aimsPalette from "./meridian-theme-aims.json";
import aimsGrayPalette from "./meridian-theme-aims-gray.json";

export const THEME_COLOR = {
  // Neutrals, lightest to darkest.
  WHITE: "#FFFFFF",
  MIST_GRAY: aimsGrayPalette.palette50,
  FROST_GRAY: aimsGrayPalette.palette100,
  PALE_GRAY: aimsGrayPalette.palette200,
  MID_GRAY: aimsGrayPalette.palette500,
  CHARCOAL_GRAY: aimsGrayPalette.palette700,
  BLACK: "#000000",
  // Brand teal ramp.
  MINT_GREEN: aimsPalette.palette50,
  LIGHT_TEAL: aimsPalette.palette100,
  TURQUOISE: aimsPalette.palette200,
  SEAFOAM_GREEN: aimsPalette.palette300,
  MUTED_TEAL: aimsPalette.palette400,
  TEAL_GREEN: aimsPalette.palette500,
  DEEP_TEAL: aimsPalette.palette600,
  DARKEST_TEAL: aimsPalette.palette700,
  // Meridian success green.
  MOSS_GREEN: colorSuccess500,
  // Meridian error / red tokens.
  CORAL_RED: colorError200,
  CRIMSON: colorCrimson600,
  DARK_MAROON: colorError800,
  BLUSH: colorError50,
  ROSE: colorRed100,
  // Lavender (no Meridian match).
  LIGHT_LAVENDER: "#F7F6F8",
};
